import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CustomTextField from "../custom/CustomTextField";
import { isBlank } from "../../utils/ValidationRules";
import CustomButton from "../custom/CustomButton";
import apiClient from "../../utils/apiClient";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";

const EditPublikasiModal = ({ open, onClose, userId, journalId, onSuccess }) => {
  const [namaPublikasi, setNamaPublikasi] = useState("");
  const [judulPublikasi, setJudulPublikasi] = useState("");

  useEffect(() => {
    if (!open || !journalId) return;

    const fetchJournalData = async () => {
      try {
        const response = await apiClient.get(
          `/journal?journalId=${journalId}&lecturerId=${userId}`
        );
        const data = response.data.data[0];
        setNamaPublikasi(data.judul);
        setJudulPublikasi(data.nama_jurnal);
      } catch (err) {
        showErrorToast("Failed to fetch journal data");
      }
    };

    fetchJournalData();
  }, [journalId, userId, open]);

  const editPublikasi = (event) => {
    event.preventDefault();
    Swal.fire({
      text: "Merubah data publikasi ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, rubah",
      cancelButtonText: "Tidak, jangan rubah",
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .put(`/journal`, {
            idJurnal: parseInt(journalId, 10),
            namaJurnal: namaPublikasi,
            judul: judulPublikasi,
          })
          .then((response) => {
            showSuccessToast(response.data.msg);
            onSuccess();
          })
          .catch((err) => {
            showErrorToast(err.response.data.msg);
          });
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Publikasi</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Typography>
              Nama Publikasi<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={namaPublikasi}
              rule={(value) => isBlank(value, "Nama Publikasi")}
              onChange={(event) => setNamaPublikasi(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Judul Publikasi<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={judulPublikasi}
              rule={(value) => isBlank(value, "Judul Publikasi")}
              onChange={(event) => setJudulPublikasi(event.target.value)}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomButton
              text="Submit"
              baseColor="#003158"
              hoverColor="#00213A"
              onClick={editPublikasi}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EditPublikasiModal;
